import { useClipboard } from '@vueuse/core';

// @ts-expect-error legacy message service is not typed yet
import message from '@/components/base-components/services/message';

type MessageMethod = 'success' | 'warning';
type MessageOptions = {
    html: boolean;
    message: string;
};
type MessageService = Partial<Record<MessageMethod, (options: MessageOptions) => unknown>>;

const clipboard = useClipboard({ legacy: true });
const messageService = message as MessageService;

function toastMessage(show: boolean, method: MessageMethod, text: string) {
    if (!show || !messageService[method]) return;

    messageService[method]?.({
        html: true,
        message: text,
    });
}

function formatValue(value: string) {
    return value.length > 30 ? `${value.slice(0, 30)}...` : value;
}

export async function copyToClipboard(value: unknown, toast = true) {
    const text = String(value ?? '');
    const formatted = formatValue(text);

    try {
        await clipboard.copy(text);
        toastMessage(toast, 'success', `<b>${formatted}</b> copied to clipboard`);
    } catch {
        toastMessage(toast, 'warning', `Can't copy <b>${formatted}</b> to clipboard!`);
    }
}

export default copyToClipboard;
